import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_MEDIUM_SCREEN_750 } from 'client/constants/mediaQueries';

import { MOBILE_APP_DOWNLOAD_LINK } from 'common/partnerConstants';

import SrBanner from '../SrBanner/SrBanner';
import SrBox from '../SrBox';

const SrPartnerInstallMobileAppBanner = () => {
  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN_750,
  });

  return (
    <SrBanner
      title="Download the Sunroom Leasing App!"
      subtitle="Take your leases with you, wherever you are!"
      iconUrl="/images/partner-app-icon.svg"
      to={isMediumScreen ? MOBILE_APP_DOWNLOAD_LINK : '/download-mobile-app-link'}
    >
      <SrBox marginRight="16px" display="inlineBlock">
        <img alt="ios banner" src="/images/ios-badge.svg" height="36px" width="auto" />
      </SrBox>
      <img alt="android banner" src="/images/android-badge.svg" height="36px" width="auto" />
    </SrBanner>
  );
};

SrPartnerInstallMobileAppBanner.displayName = 'SrPartnerInstallMobileAppBanner';

export default SrPartnerInstallMobileAppBanner;
